import React, { Component } from "react";


export class CustomTable extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <table className={this.props.customClassName}>
        {this.props.children}
      </table>
    );
  }
}
